export default __webpack_public_path__ + "static/LAPTOP_MOCKUP_TRANSPARENT-454e1fc1e234d29744d0cde60562127c.png";